import { useState, useRef, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
} from "react-bootstrap";

import axios from "axios";
import ProgressBar from '../Utilities/ProgressBar';
import { ModalConfirm } from '../Utilities/Modal';

function UploaderButton({ dropZoneId, onDrag, children, accept = ''   }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showConfirm, setshowConfirm] = useState([]);
  const [progress, setProgress] = useState();
  const [file, setFile] = useState();
  const [error, setError] = useState();

  const inputFile = useRef(null);
  const dragCounter = useRef(0);

  useEffect(() => {
    if (dropZoneId) {
      const dropZone = document.getElementById(dropZoneId);
      if (dropZone) {
        const handleDrag = (e) => {
          console.log('handleDrag')
          e.preventDefault();
          e.stopPropagation();
        };

        const handleDragIn = (e) => {
          console.log('handleDragIn')
          e.preventDefault();
          e.stopPropagation();
          dragCounter.current++;
          if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            onDrag(true);
          }
        };

        const handleDragOut = (e) => {
          console.log('handleDragOut')
          e.preventDefault();
          e.stopPropagation();
          dragCounter.current--;
          if (dragCounter.current === 0) {
            onDrag(false);
          }
        };

        const handleDrop = (e) => {
          console.log('handleDrop')
          e.preventDefault();
          e.stopPropagation();
          dragCounter.current = 0;
          onDrag(false);
          if (e.dataTransfer.files && e.dataTransfer.files[0] && isValidFileType(e.dataTransfer.files[0])) {
            const droppedFile = e.dataTransfer.files[0];
            setFile(droppedFile);
            setshowConfirm(true);
            e.dataTransfer.clearData();
          }
        };

        dropZone.addEventListener('dragenter', handleDragIn);
        dropZone.addEventListener('dragover', handleDrag);
        dropZone.addEventListener('dragleave', handleDragOut);
        dropZone.addEventListener('drop', handleDrop);

        return () => {
          dropZone.removeEventListener('dragenter', handleDragIn);
          dropZone.removeEventListener('dragover', handleDrag);
          dropZone.removeEventListener('dragleave', handleDragOut);
          dropZone.removeEventListener('drop', handleDrop);
        };
      }
    }
  }, [dropZoneId]);  

  const axiosInstance = axios.create({
    baseURL: '//' + window.sdk.getApiUrl()
  });

  const submitHandler = (file) => {
    closeModalConfirm();
    let formData = new FormData();
    formData.append("file", file);
    //Clear the error message
    setError("");

    let headers = {
      "Content-Type": "multipart/form-data",
    }
    for (var i in window.sdk.fetch().globalHeaders) {
      headers[window.sdk.fetch().globalHeaders[i].key] = window.sdk.fetch().globalHeaders[i].value;
    }

    axiosInstance
      .post("/upload-file", formData, {
        headers,
        onUploadProgress: (data) => {
          //Set the progress value to show the progress bar
          setProgress(Math.round((100 * data.loaded) / data.total));
        }
      })
      .then(() => {
        setFile(false);
        setshowConfirm(false)
        setProgress(false)
      })
      .catch((error) => {
        const { code } = error?.response?.data;
          switch (code) {
            case "FILE_MISSING":
              setError("Veuillez sélectionner un fichier avant de le télécharger");
              break;
            case "LIMIT_FILE_SIZE":
              setError("Le fichier est très volumineux. ");
              break;
            case "INVALID_TYPE":
              setError(
                "Ce type de fichier n'est pas pris en charge. Seuls les fichiers image, vidéo et pdf sont autorisés"
              );
              break;
  
            default:
              setError("Désolé! Quelque chose s'est mal passé. Veuillez réessayer plus tard");
              break;
          }
        });
  };
  const openModalConfirm = (e) => {

    let selectedFiles = e.target.files;
    console.log(selectedFiles, accept, isValidFileType(selectedFiles[0]))
    if (selectedFiles[0] && isValidFileType(selectedFiles[0])) {
      setFile(selectedFiles[0]);
      setshowConfirm(true)
    }
  }
  const closeModalConfirm = () => {
    setFile(false);
    setshowConfirm(false)
    setProgress(false)
  }

  const isValidFileType = (file) => {
    if (!accept) return true;
    const acceptedTypes = accept.split(',').map(t => t.trim());

    return acceptedTypes.some(type => {
      if (type.endsWith('/*')) {
        const baseType = type.split('/')[0];
        return file.type.startsWith(baseType + '/');
      }
      return file.type === type || file.name.endsWith(type); // fallback par extension
    });
  };

  return (
    <Container className="btn-upload">
      <Form.Group>
        <Form.Control type="file"
          ref={inputFile}
          id="exampleFormControlFile1"
          label="Select a File"
          name="file"
          accept={accept}
          onChange={(e) => {
            openModalConfirm(e)
            //submitHandler(e);
          }}
          style={{ display: "none" }}
        />
      </Form.Group>
      <Form.Group>
        <div onClick={() => inputFile.current.click()}>
          {children ? 
            children
          :
            <Button className="btn btn-icon btn-size2 btn-white">
              <i className="icon-trombone" />
            </Button>
          }
        </div>
      </Form.Group>
      {error && <Alert variant="danger">{error}</Alert>}
      {!error && progress && (
        <ProgressBar now={progress} variant={'light'} textinside={true} />
      )}
      {showConfirm === true && <ModalConfirm title={"Voulez vous envoyer ce fichier suivant ?"} onConfirm={(e) => { submitHandler(file) }} onCancel={() => { closeModalConfirm() }}>
        <i className={window.sdk.session().getFileIcon(file)} /> {file.name}
      </ModalConfirm>}
    </Container>
  );
}

export default UploaderButton;